import { useContext } from 'react';
import ThumbnailBanner from './ThumbnailBanner';
import PortfolioItemContext from '../PortfolioItemContext';

const PortfolioItemThumbnailHeader = () => {
  const { portfolioItem } = useContext(PortfolioItemContext);

  if (portfolioItem.thumbnail === null) {
    return null;
  }

  return <ThumbnailBanner />;
};

export default PortfolioItemThumbnailHeader;
